
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-44d21e0f&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CurrentBlocks.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CurrentBlocks.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-44d21e0f!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CurrentBlocks.vue"),
  /* scopeId */
  "data-v-44d21e0f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/CurrentBlocks.vue
// module id = ./dev/src/components/CurrentBlocks.vue
// module chunks = 0